import AWS from 'aws-sdk';
import { parse } from 'url'; // Importing the 'parse' function from the 'url' module

const BUCKET_NAME = 'padhai-aurait-tech'
const REGION = import.meta.env.VITE_AWS_REGION;


AWS.config.update({
    region: REGION,
    accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID, 
    secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY, 
  });

const s3 = new AWS.S3();

export async function postStudentChatFile(file, studentId, chatId, filename) {
  const fileName = `Students/${studentId}/chats/${chatId}/attachment/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
  };

  try {
    // Upload file to S3
    const uploadResult = await s3.upload(params).promise();
    return uploadResult.Location; // Get the URL of the uploaded file
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postStudentAnsFile(file, studentId, assignmentId, filename) {
    const fileName = `Students/${studentId}/assignments/${assignmentId}/answerFiles/${filename}`;

    const params = {
      Bucket: BUCKET_NAME,
      Key: fileName, // Path in the S3 bucket
      Body: file,
      ContentType: file.type,
    };

    try {
      // Upload file to S3
      const uploadResult = await s3.upload(params).promise();
      return uploadResult.Location; // Get the URL of the uploaded file
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('Error uploading file');
    }
}

export async function postStudentExmFile(file, studentId, examId, filename) {
  const fileName = `Students/${studentId}/exams/${examId}/answerFiles/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
  };

  try {
    // Upload file to S3
    const uploadResult = await s3.upload(params).promise();
    return uploadResult.Location; // Get the URL of the uploaded file
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}


export async function postScreenshotStudentLibrary(file, studentId, classRoomId, filename) {
  const fileName = `Students/${studentId}/classroom/${classRoomId}/library/screenshot/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Students/${studentId}/classroom/${classRoomId}/library/screenshot/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postStudentProfilePhoto(file, studentId, filename) {
  const fileName = `Students/${studentId}/profilePhoto/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Students/${studentId}/profilePhoto/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postStudentExcallyNotes(file, studentId, filename,noteId) {
  const classRoomId=localStorage.getItem("classRoomId")
  const fileName = `Students/${studentId}/classroom/${classRoomId}/notes/${noteId}/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `Students/${studentId}/classroom/${classRoomId}/notes/${noteId}/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}


export async function postStudentDigitiseNotes(file, studentId, filename,noteTitle) {
  const classRoomId=localStorage.getItem("classRoomId")
  const fileName = `Students/${studentId}/classroom/${classRoomId}/Digitisenotes/${noteTitle}/$${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `Students/${studentId}/classroom/${classRoomId}/Digitisenotes/${noteTitle}/$${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}
export async function generatePresignedUrl(s3Url, expiresIn = 1800) {
  const parsedUrl = parse(s3Url);
  const key = decodeURIComponent(parsedUrl.pathname.slice(1));

  const params = {
    Bucket: BUCKET_NAME,
    Key: key,
    Expires: expiresIn, // 30 minutes in seconds
  };

  try {
    // Generate the pre-signed URL using S3 SDK
    const signedUrl = await s3.getSignedUrlPromise('getObject', params);
    return signedUrl;
  } catch (error) {
    console.error('Error generating pre-signed URL:', error);
    throw error;
  }
}
  export async function postDemoAccountFileStudyBuddy(file ,uuidCreated,  filename) {
  const fileName = `demo/${uuidCreated}/${file}/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/demo/${uuidCreated}/${file}/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}